import { BaseService } from '@services/BaseService';
import { OptionsViewModel, AddressViewModel, StatesViewModel, AddressValidationModel } from '@models/common.models';

class UtilityService extends BaseService {
  constructor() {
    super('util');
  }

  getStates() {
    return this.fetch<StatesViewModel[]>('States', {
      method: 'GET'
    });
  }

  getPhoneTypes() {
    return this.fetch<OptionsViewModel[]>('PhoneTypes', {
      method: 'GET'
    });
  }

  logPage(pageName: string, duration: number) {
    return this.fetch(`LogPage?pageName=${pageName}&time=${duration}`, {
      method: 'GET'
    });
  }

  validateAddress(address: AddressViewModel) {
    return this.fetch<AddressValidationModel>('verifyaddress', {
      method: 'POST',
      body: JSON.stringify(address)
    });
  }

  verifyZipCode(zip: number) {
    return this.fetch(`serviceableArea?zipCode=${zip}`, {
      method: 'GET'
    });
  }
}

export const utilityService = new UtilityService();



// WEBPACK FOOTER //
// ./src/_services/UtilityService.ts